import { CheckCircle2, Clock, XCircle, CalendarClock } from 'lucide-react';
import type { TripStatus } from '../../types/trip';
import { TRIP_STATUS_COLORS, TRIP_STATUS_LABELS } from '../../utils/trips';

const ICONS: Record<TripStatus, typeof Clock> = {
  planned: CalendarClock,
  in_progress: Clock,
  completed: CheckCircle2,
  cancelled: XCircle,
};

// FE-11: `planned` es el estado en que NACE todo viaje y el mock no lo tenía —
// un badge que no lo contemple deja en blanco justo el estado más frecuente
// de una operación que se programa con antelación.
export function TripStatusBadge({ status, size = 'sm' }: { status: TripStatus; size?: 'sm' | 'md' }) {
  const Icon = ICONS[status];
  const color = TRIP_STATUS_COLORS[status];
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: size === 'md' ? '4px 12px' : '2px 8px',
      borderRadius: '99px',
      fontSize: size === 'md' ? '12px' : '11px',
      fontWeight: 700,
      color,
      background: `${color}1F`,
      border: `1px solid ${color}44`,
      whiteSpace: 'nowrap',
    }}>
      <Icon size={size === 'md' ? 13 : 12} /> {TRIP_STATUS_LABELS[status]}
    </span>
  );
}
